const DECODING_TABLE = [
  62, -1, -1, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2,
  3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1,
  -1, -1, -1, 63, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
  43, 44, 45, 46, 47, 48, 49, 50, 51
];

const FORMAT_VERSION = 1;

const Num = typeof BigInt !== 'undefined' ? BigInt : Number;

export interface LatLngZ {
  lat: number;
  lng: number;
  z?: number;
}

function decode(encoded: string): LatLngZ[] {
  const decoder = decodeUnsignedValues(encoded);
  const header = decodeHeader(decoder[0], decoder[1]);

  const factorDegree = 10 ** header.precision;
  const factorZ = 10 ** header.thirdDimPrecision;
  const { thirdDim } = header;

  let lastLat = 0;
  let lastLng = 0;
  let lastZ = 0;
  const res = [];

  let i = 2;
  for (; i < decoder.length; ) {
    const deltaLat = toSigned(decoder[i]) / factorDegree;
    const deltaLng = toSigned(decoder[i + 1]) / factorDegree;
    lastLat += deltaLat;
    lastLng += deltaLng;

    if (thirdDim) {
      const deltaZ = toSigned(decoder[i + 2]) / factorZ;
      lastZ += deltaZ;
      res.push({
        lat: lastLat,
        lng: lastLng,
        z: lastZ
      });
      i += 3;
    } else {
      res.push({
        lat: lastLat,
        lng: lastLng
      });
      i += 2;
    }
  }

  if (i !== decoder.length) {
    throw new Error('Invalid encoding. Premature ending reached');
  }

  const result = {
    ...header,
    polyline: res
  };
  return result.polyline;
}

function decodeChar(char: string): number {
  const charCode = char.charCodeAt(0);
  return DECODING_TABLE[charCode - 45];
}

function decodeUnsignedValues(encoded: string): number[] {
  let result = Num(0) as number;
  let shift = Num(0) as number;
  const resList: number[] = [];

  encoded.split('').forEach((char) => {
    const value = Num(decodeChar(char)) as number;
    result |= (value & (Num(0x1f) as number)) << shift;
    if ((value & (Num(0x20) as number)) === Num(0)) {
      resList.push(result);
      result = Num(0) as number;
      shift = Num(0) as number;
    } else {
      shift += Num(5) as number;
    }
  });

  if (shift > 0) {
    throw new Error('Invalid encoding');
  }

  return resList;
}

function decodeHeader(
  version: number,
  encodedHeader: number
): { precision: number; thirdDim: number; thirdDimPrecision: number } {
  if (+version.toString() !== FORMAT_VERSION) {
    throw new Error('Invalid format version');
  }
  const headerNumber = +encodedHeader.toString();
  const precision = headerNumber & 15;
  const thirdDim = (headerNumber >> 4) & 7;
  const thirdDimPrecision = (headerNumber >> 7) & 15;
  return { precision, thirdDim, thirdDimPrecision };
}

function toSigned(val: number): number {
  // Decode the sign from an unsigned value
  let res = val;
  if (res & (Num(1) as number)) {
    res = ~res;
  }
  res >>= Num(1) as number;
  return +res.toString();
}

export class FlexiblePolylineDecoder {
  static decode(encoded: string): LatLngZ[] {
    return decode(encoded);
  }
}
